/**
 * Format status text for display
 */
export const formatStatus = (status: string | null | undefined): string => {
  if (!status) return '';
  // Convert IN_PROGRESS to In Progress, ON_HOLD to On Hold, etc.
  return status
    .split('_')
    .map(word => word.charAt(0) + word.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Get status color classes for different statuses
 */
export const getStatusColor = (status: string | null | undefined): string => {
  switch (status) {
    case 'PLANNING':
      return 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300';
    case 'IN_PROGRESS':
      return 'bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-300';
    case 'ON_HOLD':
      return 'bg-yellow-100 dark:bg-yellow-900/50 text-yellow-800 dark:text-yellow-300';
    case 'COMPLETED':
      return 'bg-green-100 dark:bg-green-900/50 text-green-800 dark:text-green-300';
    case 'CANCELLED':
      return 'bg-red-100 dark:bg-red-900/50 text-red-800 dark:text-red-300';
    default:
      return 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300';
  }
};

/**
 * Get milestone status color classes
 */
export const getMilestoneStatusColor = (status: string | null | undefined): string => {
  switch (status) {
    case 'PLANNED':
      return 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300';
    case 'IN_PROGRESS':
      return 'bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-300';
    case 'COMPLETED':
      return 'bg-green-100 dark:bg-green-900/50 text-green-800 dark:text-green-300';
    case 'DELAYED':
      return 'bg-red-100 dark:bg-red-900/50 text-red-800 dark:text-red-300';
    default:
      return 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300';
  }
};

/**
 * Format currency amounts
 */
export const formatCurrency = (amount: number | null | undefined, currency: string = 'USD'): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount || 0);
};

/**
 * Format date strings
 */
export const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return 'Not set';
  return new Date(dateString).toLocaleDateString();
};

/**
 * Format date time strings
 */
export const formatDateTime = (dateString: string | null | undefined): string => {
  if (!dateString) return 'Never';
  return new Date(dateString).toLocaleString();
};
